import React from 'react';
import List from './List';

const NewList = ({ ...props }) => (
  <List
    url="installer-orders?order_status=assigned"
    title="Assigned Orders"
    canManage={true}
    canChangeStatus={true}
    {...props}
  />
);

export default NewList;



// WEBPACK FOOTER //
// ./src/pages/InstallerOrders/AssignedList.js